/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { INotification } from "./data-contracts";
import { HttpClient, RequestParams } from "./http-client";

export class NotificationApi<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags Notification API
   * @name GetLatestNotification
   * @summary Get the latest notification
   * @request GET:/api/notifications/latest
   * @response `200` `INotification`
   */
  getLatestNotification = (params: RequestParams = {}) =>
    this.request<INotification, any>({
      path: `/api/notifications/latest`,
      method: "GET",
      format: "json",
      ...params,
    });
}
